module.exports = __webpack_public_path__ + "img/GYLFW_6.77fbe82e.jpg";